import { render, staticRenderFns } from "./set.vue?vue&type=template&id=4d94d87d&scoped=true&"
import script from "./set.vue?vue&type=script&lang=js&"
export * from "./set.vue?vue&type=script&lang=js&"
import style1 from "./set.vue?vue&type=style&index=1&id=4d94d87d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94d87d",
  null
  
)

export default component.exports